import type { CampaignReporting } from 'c-entity-types';
import { baseInitialState, createBaseSlice } from 'c-data';
import { createByIdNetworkRequestsActions } from 'c-lib';
import type { CampaignReportingState } from './CampaignReporting-types';

const initialState: CampaignReportingState = {
    ...baseInitialState,
    attachingConfigById: {},
};

const additionalReducers = {
    ...createByIdNetworkRequestsActions<CampaignReportingState>()<
        'attachingConfigById',
        'AttachingConfig'
    >('attachingConfigById', 'AttachingConfig'),
};

const slice = createBaseSlice<CampaignReporting, CampaignReportingState, typeof additionalReducers>(
    {
        name: 'campaignReporting',
        entityName: 'CampaignReporting',
        initialState,
        reducers: additionalReducers,
    },
);

const campaignReportingSlice = {
    campaignReportingActions: slice.slice.actions,
    campaignReportingReducer: slice.slice.reducer,
    campaignReportingAdapter: slice.adapter,
    campaignReportingSelectors: slice.selectors,
    campaignReportingThunks: slice.thunks,
};

export const {
    campaignReportingReducer,
    campaignReportingActions,
    campaignReportingAdapter,
    campaignReportingSelectors,
    campaignReportingThunks,
} = campaignReportingSlice;
